<template>
  <a-modal class="date-modal-css" v-model="showModal" title="新建" width="1000px" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <a-form-model ref="baseForm" :model="formData">
      <a-row>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="人员编码"
            prop="employeeCode"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <global-select
              :allow-clear="false"
              ref="employeeCodeRef"
              :value.sync="formData.employeeCode"
              selectType="selectAssembleSearch"
              requestApi="/bom/employee/list"
              :selectItem="{ value: 'employeeCode', label: 'employeeName' }"
              searchParam="employeeCode"
              @change="onChangeEmployee"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="请假日期"
            prop="leaveTime"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-date-picker style="width: 100%" v-model="formData.leaveTime" valueFormat="YYYY-MM-DD 00:00:00" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="请假小时数"
            prop="leaveHour"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-input-number
              style="width: 100%"
              v-model="formData.leaveHour"
              :min="0"
              :max="24"
              :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
              :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="备注"
            prop="remark"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-input type="textarea" :autoSize="{minRows:2}" v-model="formData.remark" :maxLength="100" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <div class="footer-btn-wrapper">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit">确认</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { apiEmployeeLeaveCcSaveOrUpdate } from '@/api/mes/productionPrepare/leaveEntry'
export default {
  name: 'LeaveAddRoleModal',
  data () {
    return {
      loading: false,
      showModal: false,
      searchOrg: '', // 查询组织
      formData: {
        employeeCode: undefined,
        employeeName: undefined,
        leaveTime: undefined,
        leaveHour: undefined,
        remark: undefined
      }
    }
  },
  methods: {
    // 展示
    show() {
      this.reset()
      this.showModal = true
    },
    // 取消
    onCancel() {
      this.showModal = false
    },
    // 重置
    reset() {
      this.formData = {
        employeeCode: undefined,
        employeeName: undefined,
        leaveTime: undefined,
        leaveHour: undefined,
        remark: undefined
      }
    },
    // 获取人员信息
    onChangeEmployee(val, data) {
      if(val && data?.length > 0) {
        this.formData.employeeName = data.find(item => item?.employeeCode === val)?.employeeName
      }
    },
    // 提交
    onSubmit() {
      this.$refs.baseForm.validate(valid => {
        if(valid) {
          this.loading = true
          apiEmployeeLeaveCcSaveOrUpdate(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success('新增成功')
              this.$emit('refreshFun')
              this.showModal = false
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$message.warning('请检查必填项')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
